<div class="footer">
    <!-- Logos color -->
    <div class="content-logos">
        <div class="logos" *ngIf="color == true">
            <img
              src="./assets/img/financiado_por_la_Union_Europea.png"
              alt=""
              class="img-fluid"
            />
            <img
              src="./assets/img/plan-recuperacion.png"
              alt=""
              class="img-fluid"
            />
            <img
              src="./assets/img/ministerio-ciencia.png"
              alt=""
              class="img-fluid"
            />
        </div>

        <!-- Logos blanc i negre -->
        <div class="logos" *ngIf="color == false">
            <img
              src="./assets/img/financiado_por_la_Union_Europea_bn.png"
              alt=""
              class="img-fluid"
            />
            <img
              src="./assets/img/plan-recuperacion-bn.png"
              alt=""
              class="img-fluid"
            />
            <img
              src="./assets/img/ministerio-ciencia-bn.png"
              alt=""
              class="img-fluid"
            />
        </div>
    </div>
</div>